import React, { useEffect, useState } from "react";
import { Grid, CircularProgress } from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase/firebase";
import { useResponsive } from "../../../../Modulo_Responsive/Hooks/useResponsive";

const ListaClientes = () => {
    const { sCell } = useResponsive();
    const [imagenes, setImagenes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchImagenes = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "cono-gratis"));
                const data = querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                data.sort((a, b) => {
                    if (a.orden !== undefined && b.orden !== undefined) return a.orden - b.orden;
                    if (a.orden !== undefined) return -1;
                    if (b.orden !== undefined) return 1;
                    return 0;
                });
                setImagenes(data);
            } catch (error) {
                console.error("❌ Error cargando imágenes de clientes:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchImagenes();
    }, []);

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" sx={{ width: "100%", minHeight: "100vh" }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Grid
            container
            size={{ xs: 12, sm: 8, md: 5 }}
            justifyContent="center"
            alignItems="center"
            spacing={1}
            sx={{ width: "100%", pt: 4 }}
        >
            {imagenes.map((img) => (
                <Grid
                    item
                    key={img.id}
                    size={{ xs: 6, sm: 6, md: 6 }}
                    sx={{
                        p: 0.5,
                        border: "1px solid black",
                        borderRadius: 0,
                        height: sCell ? 250 : "70%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "hidden",
                    }}
                >
                    <img
                        src={img.url}
                        alt={img.nombre || "imagen cliente"}
                        style={{
                            width: "100%",
                            height: sCell?"100%":"70%",
                            objectFit: "cover",
                        }}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default ListaClientes;